let ChartType = {
  /**
   * 今日充值
   */
  payment: 1,

  /**
   * 今日提现
   */
  backMoney: 2,

  /**
   * 今日投注
   */
  orderMoney: 3,

  /**
   * 今日返佣
   */
  proxyAmount: 4,

  /**
   * 今日新增会员
   */
  countNewUser: 5,

  /**
   * 今日活跃
   */
  countActiveUser: 6
}

export default ChartType;



// WEBPACK FOOTER //
// ./src/Store/Pandect/MySummary/ChartTypeEnum.js